export enum StrategyPageMainPanelTab {
  TRADING_DATA = 'TRADING_DATA',
  TRADING_HISTORY = 'TRADING_HISTORY',
}
